import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isNone as t } from "../../../../../core/maybe.js";
import { f as r } from "../../../../../chunks/vec4f32.js";
import { createProgramDescriptor as s } from "../Utils.js";
import e from "./WGLBrush.js";
import { background as o } from "../shaders/BackgroundPrograms.js";
import { createProgram as i } from "../../../../webgl/programUtils.js";

var a = function a() {
  return s("clip", {
    geometry: [{
      location: 0,
      name: "a_pos",
      count: 2,
      type: 5122
    }]
  });
};

var n = /*#__PURE__*/function (_e) {
  _inherits(n, _e);

  var _super = _createSuper(n);

  function n() {
    var _this;

    _classCallCheck(this, n);

    _this = _super.apply(this, arguments), _this._color = r(0, 1, 0, 1);
    return _this;
  }

  _createClass(n, [{
    key: "dispose",
    value: function dispose() {
      this._program && this._program.dispose();
    }
  }, {
    key: "prepareState",
    value: function prepareState(_ref) {
      var t = _ref.context;
      t.setStencilTestEnabled(!0), t.setBlendingEnabled(!1), t.setFaceCullingEnabled(!1), t.setColorMask(!1, !1, !1, !1), t.setStencilOp(7680, 7680, 7681), t.setStencilWriteMask(255), t.setStencilFunction(519, 0, 255);
    }
  }, {
    key: "draw",
    value: function draw(r, s) {
      var e = r.context,
          _n = r.state,
          m = a(),
          p = s.getVAO(e, _n, m.attributes, m.bufferLayouts);
      t(p.indexBuffer) || (this._program || (this._program = i(e, o)), e.useProgram(this._program), this._program.setUniform2fv("u_coord_range", [1, 1]), this._program.setUniform4fv("u_color", this._color), this._program.setUniformMatrix3fv("u_dvsMat3", _n.displayMat3), e.bindVAO(p), e.drawElements(4, p.indexBuffer.size, 5125, 0), e.bindVAO());
    }
  }]);

  return n;
}(e);

export { n as default };